import { DtoRequestExpensessPostReq } from "./abst/DtoRequestExpensessPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestExpensessPostReqImple extends DtoRequestExpensessPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
